import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { EditClassifierFields } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';

export const updateClassifierValidation = z.object({
	[EditClassifierFields.name]: z.string().optional(),
	[EditClassifierFields.archive]: z.boolean().optional(),
	[EditClassifierFields.classifierParentId]: z.string().optional(),
});

export const updateClassifierResolver = zodResolver(updateClassifierValidation);
